export enum EditionRightMode {
  CREATE = 'CREATE',
  MODIFY = 'MODIFY',
}
